import React from 'react';
import {
  BannerContainer,
  BannerContent,
  TextColumn,
  MainHeading,
  BenefitsList,
  BenefitItem,
  CheckIcon,
  BenefitText,
  ActionButton,
  PersonColumn,
  PersonImage,
  OrangeCircle,
  LightBlueShape
} from './styles';

import womanImage from '../../../images/model.png';

const Section8 = () => {
  return (
    <BannerContainer>
      <BannerContent>
        <PersonColumn>
          <PersonImage src={womanImage} alt="Mulher sorrindo" />
        </PersonColumn>
        
        <TextColumn>
          <MainHeading>
            Confira Planos Especiais e Condições de Pagamento!
          </MainHeading>
          
          <BenefitsList>
            <BenefitItem>
              <CheckIcon>✓</CheckIcon>
              <BenefitText>Cupons Exclusivos</BenefitText>
            </BenefitItem>
            
            <BenefitItem>
              <CheckIcon>✓</CheckIcon>
              <BenefitText>Teste 7 Dias Grátis</BenefitText>
            </BenefitItem>
          </BenefitsList>
          
          <ActionButton>Conferir</ActionButton>
        </TextColumn>
      </BannerContent>
      
      <OrangeCircle />
      <LightBlueShape />
    </BannerContainer>
  );
};

export default Section8;
